import React, {useState, useEffect} from 'react';
import List from './List';
import Display from './Display';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

const Advantages = (props) => {

  const [active, setActive] = useState({
    index: 0,
    item: props.items[0]
  })

  const handleHover = (newItem, newIndex) => {
    setActive({
      index: newIndex,
      item: newItem
    })
  }
  
  useEffect(() => {
    const interval = setInterval(() => {
      if (active.index < props.items.length - 1) {
        setActive({
          index: active.index + 1,
          item: props.items[active.index + 1]
        });
      }
      else {
        setActive({
          index: 0,
          item: props.items[0]
        });
      }
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [active.index, props.items]);

  return (
    <section>
      <Container>
        <Grid container direction='column' alignItems='center'>
          <Display item={active.item} />
          <List items={props.items} index={active.index} onMouseEnter={handleHover}/>
        </Grid>
      </Container>
    </section>
  );
}

export default Advantages;